export const FINANCE_MODULE_KEY_MAPPING = {
  KEY_METRICS: 'key_metrics',
  TRENDS: 'trends',
};
